<template lang='pug'>
svg.icon(aria-hidden="false", v-if="iconName", :class='className')
  use(:xlink:href="iconName")
</template>

<script>
  export default {
    name: 'symbol-svg',
    props: {
      iconSuffix: {
        type: String,
        default: ''
      },
      className: {
        type: String,
        default: ''
      }
    },

    computed: {
      iconName() {
        return `#el-icon-mgmt-${this.iconSuffix}`
      }
    }
  }
</script>
